const breakpoints = ['40em', '52em', '64em', '80em']

export const mq = breakpoints.map(bp => `@media (min-width: ${bp})`)
